import { Cog, Cpu, Sun } from "lucide-react";

const ITEMS = [
  {
    icon: Cog,
    title: "Beni materiali",
    desc: "Macchinari, impianti, robot e sistemi di produzione interconnessi (Allegato IV, L. 199/2025).",
  },
  {
    icon: Cpu,
    title: "Beni immateriali · Software",
    desc: "Software, piattaforme e applicazioni funzionali all'automazione dei processi produttivi (Allegato V, L. 199/2025).",
  },
  {
    icon: Sun,
    title: "Autoproduzione da rinnovabili",
    desc: "Impianti fotovoltaici, eolici, sistemi di accumulo per autoconsumo dell'impresa (art. 1 c. 428, L. 199/2025).",
  },
];

export default function CosaAgevolabile() {
  return (
    <section className="py-16 md:py-20 bg-white" data-testid="cosa-agevolabile">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-[10px] font-display tracking-[0.3em] uppercase text-brand-dark">
            Investimenti ammissibili
          </div>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl text-ink">
            Cosa è <span className="text-brand">agevolabile</span>
          </h2>
          <p className="mt-4 text-sm text-ink-muted">
            Sintesi delle principali categorie di beni ammessi all'Iperammortamento 2026 (L. 30/12/2025 n. 199).
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={i}
                className="border border-line rounded-md p-6 hover:border-brand/50 hover:shadow-card-hover transition"
                data-testid={`agevolabile-${i}`}
              >
                <div className="w-10 h-10 rounded bg-brand/10 text-brand flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-4 font-display text-base tracking-wide text-ink">{it.title}</h3>
                <p className="mt-2 text-sm text-ink-muted leading-relaxed">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
